export default class ComponentHeader {
    constructor() {
        this.lastScroll = 0
        this.appHeader = document.querySelector('.component-header');
        this.openCloseButton = document.querySelector('.component-header .top .open-close-container');
        this.navigationContainer = document.querySelector('.component-header .top .navigation-container');
        this.mobileNavigation = document.querySelector('.component-header .mobile-navigation');
        this.setEvents();
        this.updateLogoSource()
    }
    
    setEvents() {
        window.addEventListener('scroll', this.eventScroll.bind(this));
        window.addEventListener('resize', this.updateLogoSource.bind(this));

        // Attach the click event listener to a parent element (e.g., the top navigation container)
        // this.navigationContainer.addEventListener('click', this.eventClick.bind(this));
        this.openCloseButton.addEventListener('click', this.eventClick.bind(this));
    }

    updateLogoSource() {
        const logoImg = document.querySelector('.logo-container img')
    
        if (!logoImg) return
    
        const desktopLogoUrl = logoImg.getAttribute('data-desktop-logo')
        const mobileLogoUrl = logoImg.getAttribute('data-mobile-logo')
        const isScrollDown = this.appHeader.classList.contains('scroll-down')
        const isMobile = window.innerWidth <= 992
        let newLogoUrl = ''
    
        if ((isMobile && isScrollDown) || (isMobile && !isScrollDown)) {
            newLogoUrl = mobileLogoUrl
        } else if (!isMobile && isScrollDown) {
            newLogoUrl = mobileLogoUrl
        } else if (!isMobile && !isScrollDown) {
            newLogoUrl = desktopLogoUrl
        }
    
        const currentLogoUrl = logoImg.getAttribute('srcset')
    
        if (newLogoUrl !== currentLogoUrl) {
            logoImg.style.opacity = 0
    
            setTimeout(() => {
                logoImg.setAttribute('srcset', newLogoUrl)
                logoImg.style.opacity = 1
            }, 300)
        }
    }
    
    eventScroll() {
        let currentScroll = window.pageYOffset
        if (currentScroll <= 0) {
            this.appHeader.classList.remove('scroll-down')
            this.updateLogoSource()
            return
        }
        if (currentScroll > this.lastScroll) {
            this.appHeader.classList.add('scroll-down')
        } 
        else if (currentScroll < this.lastScroll) {
            // if scrolling up
        }

        this.updateLogoSource()
        this.lastScroll = currentScroll;
    }
    
    eventClick(event) {
        console.log('event', event)

        if (this.mobileNavigation.classList.contains('active')) {
            this.mobileNavigation.classList.remove('active')
            this.openCloseButton.classList.remove('active')
            this.appHeader.classList.remove('mobile-active')
        } else {
            this.mobileNavigation.classList.add('active')
            this.openCloseButton.classList.add('active')
            this.appHeader.classList.add('mobile-active')
        }
    }
}